import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, skipWhile, switchMap, take } from 'rxjs/operators';

import { RootState } from '../root-store/root-state';
import { UserMeStoreSelectors } from '../root-store/user-me-store';
import { TOKEN_SERVICE } from '@app/core/tokens/token-service.token';
import { ITokenService } from '@app/models/objects/token-service.model';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordGuard {
  constructor(
    private store: Store<RootState>,
    private router: Router,
    @Inject(TOKEN_SERVICE) private tokenService: ITokenService,
  ) {}

  canActivate() {
    return this.getFromStore().pipe(
      switchMap(() => {
        this.router.navigate(['/me']);
        return of(true);
      }),
      catchError(() => {
        this.tokenService.delete();
        return of(true);
      }),
    );
  }

  getFromStore() {
    return this.store.pipe(
      select(UserMeStoreSelectors.selectState),
      skipWhile((userMeState) => userMeState.isLoading === true),
      filter((userMeState) => !!userMeState.data.id),
      take(1),
    );
  }
}
